import React from 'react';
import { Layers, Settings2 } from 'lucide-react';

/**
 * Shared sub-tabs for Engineering section.
 * Add new tools here as they are built (same pattern as Technical tabs).
 * `accessGroups` controls which Cognito groups can see each tab (admin/super-admin always see all).
 */
export const ENGINEERING_TAB_ITEMS = [
  {
    id: 'coil-configurator',
    label: 'Coil Configurator',
    path: '/engineering',
    icon: <Settings2 size={18} />,
    accessGroups: ['coil_configurator'],
  },
  {
    id: 'on-pipe-configurator',
    label: 'On-Pipe Configurator',
    path: '/engineering/on-pipe',
    icon: <Layers size={18} />,
    accessGroups: ['on_pipe_configurator'],
  },
];

/** Routes that belong under the Engineering sidebar section. */
export const ENGINEERING_NAV_PATHS = [
  '/coil-configurator',
  ...ENGINEERING_TAB_ITEMS.map((item) => item.path),
];

export const isEngineeringNavPath = (pathname = '') =>
  ENGINEERING_NAV_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

export const userCanAccessEngineering = (userGroup = []) => {
  const g = Array.isArray(userGroup) ? userGroup : [];
  if (g.includes('super-admin') || g.includes('admin')) return true;
  return ENGINEERING_TAB_ITEMS.some((item) =>
    (item.accessGroups || []).some((group) => g.includes(group)),
  );
};

export const filterEngineeringTabsForUser = (userGroup = []) => {
  const g = Array.isArray(userGroup) ? userGroup : [];
  if (g.includes('super-admin') || g.includes('admin')) return ENGINEERING_TAB_ITEMS;
  return ENGINEERING_TAB_ITEMS.filter((item) =>
    (item.accessGroups || []).some((group) => g.includes(group)),
  );
};

/** First Engineering tab the user can open (for sidebar / redirects). */
export const getDefaultEngineeringPath = (userGroup = []) => {
  const tabs = filterEngineeringTabsForUser(userGroup);
  return tabs[0]?.path || '/engineering';
};
